var React = require('react');

function WarningColor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#f5440f;}.cls-2{fill:#081319;}")),React.createElement("title",{"key":1},"warning-triangle-colour"),React.createElement("path",{"data-style":"background","d":"M17,2a1,1,0,0,0-.86.45L1.19,28.29A1.09,1.09,0,0,0,2.06,30H31.94a1.09,1.09,0,0,0,.9-1.67l-15-25.84A1,1,0,0,0,17,2Z","key":2}),React.createElement("path",{"d":"M15.6,14.73,15.5,12h3l-.1,2.73L18,21H16Z","key":3}),React.createElement("circle",{"cx":"17","cy":"24.5","r":"1.5","key":4})]);
}

WarningColor.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = WarningColor;

WarningColor.default = WarningColor;
